import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import queryString from "query-string";
import { useEffect, useState } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useStoreFullName } from "@/components/Store/utils/useStoreFullName.hook";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { noEmptyValueFormatter } from "@/utils/textUtils";

import EditPreferencesModal from "./Modal/modal.container";

type Props = {
    customer: ComponentsCustomer;
    storeDetails?: CloudStore;
};

const ProfilePreferences = ({ customer, storeDetails }: Props) => {
    const { t } = useGranite();
    const [isModalOpen, setModalOpen] = useState(false);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const { editpreferencessuccess } = queryString.parse(location.search);
        if (editpreferencessuccess === "true") {
            broadcastMessage({
                id: "edit-preferences-success",
                text: t("general.profile.editpreferences.modal.success"),
                status: "success",
                dismissible: true,
                activeScroll: true
            });
        }
    }, []);

    const storeFullName = useStoreFullName(storeDetails);

    return (
        <>
            <div>
                <Row>
                    <Col
                        xs={6}
                        md={3}
                    >
                        <p>{t("profilePreferences.label.preferredLanguage")}</p>
                    </Col>
                    <Col>
                        <p>
                            {noEmptyValueFormatter(
                                t(`general.language.${customer.language}`),
                                customer.language
                            )}
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={6}
                        md={3}
                    >
                        <p>{t("profilePreferences.label.preferredStore")}</p>
                    </Col>
                    <Col>
                        <p>
                            {noEmptyValueFormatter(
                                storeFullName,
                                customer.favouriteStoreId
                            )}
                        </p>
                    </Col>
                </Row>
                <Row className={cn("mt-3")}>
                    <Col>
                        <Button
                            test="profilePreferences-button-changePreferences"
                            className={"pl-0"}
                            color="link"
                            type="button"
                            onClick={() => setModalOpen(true)}
                        >
                            <i className={cn("las la-pencil-alt", "mr-2")} />
                            {t("profilePreferences.link.changePreferences")}
                        </Button>
                    </Col>
                </Row>
            </div>
            <EditPreferencesModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
            />
        </>
    );
};

export default ProfilePreferences;
